import React from "react"
import SEO from "../components/Seo"

const IndexPage = () => (  
    <SEO
      title="Hire developers in days instead of months"
      description="In Avalith are passionate about the development of digital products. We have been empowering big companies from our home for more than 10 years."
    />      
)

export default IndexPage
